'use client'

import { LuneTheme } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Circula from '@public/images/logos/circula.png'
import CrownAgentsBank from '@public/images/logos/crown-agents-bank.png'
import Payhawk from '@public/images/logos/payhawk.png'
import Simfoni from '@public/images/logos/simfoni.png'
import Soldo from '@public/images/logos/soldo.png'
import Visa from '@public/images/logos/visa.png'
import Zoho from '@public/images/logos/zoho.png'

import LogosGrid from '@/components/LogosGrid'

const logos = [
    {
        name: 'Visa',
        img: Visa,
        width: 52.45,
        height: 17,
    },
    {
        name: 'Payhawk',
        img: Payhawk,
        width: 96.48,
        height: 22,
    },
    {
        name: 'Zoho',
        img: Zoho,
        width: 89.26,
        height: 38,
    },
    {
        name: 'Crown Agents Bank',
        img: CrownAgentsBank,
        width: 111.25,
        height: 32,
    },
    {
        name: 'Circula',
        img: Circula,
        width: 87,
        height: 22,
    },
    {
        name: 'Soldo',
        img: Soldo,
        width: 77.73,
        height: 22,
    },
    {
        name: 'Simfoni',
        img: Simfoni,
        width: 73.5,
        height: 32,
    },
]

const PaymentsLogos = () => {
    const { palette } = LuneTheme
    return (
        <Box
            sx={{
                position: 'relative',
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    bottom: 0,
                    left: '-50%',
                    right: '-50%',
                    height: '1px',
                    backgroundColor: `${palette.Grey300}`,
                    mx: {
                        lg: 37,
                        xl: 37,
                    },
                },
            }}
        >
            <LogosGrid sx={{ pt: 6, pb: 6 }} logos={logos} />
        </Box>
    )
}

export default PaymentsLogos
